<ui-input-wrapper
  class="block w-full"
  [help]="base.help"
  [helpTooltipPosition]="base.helpTooltipPosition()"
  [label]="base.label"
  [addAsteriskToFakeRequiredLabel]="base.addAsteriskToFakeRequiredLabel()"
  [errors]="getFormControl.errors"
  [errorLabels]="base.errorLabels()"
  [forceShowValidationErrors]="base.forceShowValidationErrors()"
  [control]="control"
  [randomInputId]="randomInputId"
  [submitted]="submitted">
  <p-autocomplete
    class="flex w-full"
    [placeholder]="base.placeholder || base.label"
    [formControl]="getFormControl"
    [optionValue]="autoComplete.optionValue()"
    [dataKey]="autoComplete.dataKey() ?? ''"
    [dropdown]="autoComplete.dropdown()"
    [readonly]="base.readonly()"
    [inputId]="randomInputId"
    (onKeyUp)="handleChange.emit(getFormControl.value)"
    [showEmptyMessage]="true"
    [suggestions]="select.options()"
    [emptyMessage]="select.emptyMessage() ?? ''"
    [forceSelection]="autoComplete.forceSelection()"
    [showClear]="autoComplete.showClear()"
    (completeMethod)="handleAction.emit($event)"
    [autoHighlight]="autoComplete.autoHighlight()"
    (onBlur)="handleChange.emit(getFormControl.value)"
    (onSelect)="handleChange.emit(getFormControl.value)"
    (onUnselect)="handleChange.emit(getFormControl.value)"
    (onClear)="onClearHandler()"
    [minQueryLength]="autoComplete.minSearchLength()"
    [multiple]="autoComplete.multiple()"
    [optionLabel]="autoComplete.optionLabel() ?? autoComplete.field() ?? undefined"
    [appendTo]="autoComplete.appendTo()">
    <ng-template let-country #footer>
      @if (select.options().length >= MAX_OPTIONS_LENGTH) {
        <!-- patička seznamu zůstává dole při scrollu (šablona patičky patří této komponentě, platí i v overlayi v body) -->
        <div
          class="sticky bottom-0 left-0 w-full z-1 p-3 bg-(--background-block-primary) [box-shadow:inset_0px_1px_0px_0px_var(--border-subtle),inset_0px_-1px_0px_0px_var(--border-subtle)] italic text-[90%]">
          Pro zobrazení dalších možností zadejte více znaků
        </div>
      }
    </ng-template>
  </p-autocomplete>
</ui-input-wrapper>
